<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <button routerLink="/backoffice/configuration/collections" class="btn btn-sm btn-primary"><i class="fa fa-chevron-left"></i> Back</button>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-book"></i> Albums
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
              <i class="fa fa-plus"></i> Add Album
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline align-middle mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Image</th>
                <th>Name</th>
                <th>Cards Count</th>
                <th>Rewards</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="8" class="text-center">
                    <span class="spinner-border spinner-border-sm"></span> Loading...
                  </td>
                </tr>
              } @else if (albums.length === 0) {
                <tr>
                  <td colspan="8" class="text-center text-muted">No album found.</td>
                </tr>
              } @else {
                @for (album of albums; track album.albumId; let i = $index) {
                  <tr>
                    <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                    <td>{{ album.albumId }}</td>
                    <td>
                      @if (hasImage(album)) {
                        <img [src]="getImageUrl(album)" alt="" style="max-height: 48px; max-width: 64px; object-fit: contain;">
                      } @else {
                        <span class="text-muted">-</span>
                      }
                    </td>
                    <td>{{ album.name }}</td>
                    <td>{{ album.cardsCount }}</td>
                    <td>
                      @for (reward of album.rewards; track reward.rewardId) {
                        <span class="badge bg-secondary me-1">
                          {{ getCurrencyTypeName(reward.currencyType) }} × {{ reward.currencyQuantity }}
                          @if (reward.currencyTicketCost > 0) {
                            ({{ reward.currencyTicketCost }} tickets)
                          }
                        </span>
                      } @empty {
                        <span class="text-muted">-</span>
                      }
                    </td>
                    <td>
                      @if (!hasImage(album)) {
                        <span class="badge bg-danger me-1">Image missing</span>
                      }
                      @if (getMissingTranslationsCount(album) > 0) {
                        <span class="badge bg-danger">{{ getMissingTranslationsCount(album) }} translations missing</span>
                      }
                    </td>
                    <td>
                      <div class="btn-group me-1">
                        <button class="btn btn-sm btn-primary" type="button" routerLink="/backoffice/configuration/collection-cards" [queryParams]="{ id: album.albumId, collectionId: collectionId }" tooltip="Cards" placement="top"><i class="fa fa-list"></i></button>
                        <button class="btn btn-sm btn-warning" type="button" (click)="onClickEdit(album)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                        <button class="btn btn-sm btn-info" type="button" [disabled]="uploadingImageId === album.albumId" (click)="onClickUploadImage(album)" tooltip="Upload image (PNG, 2 MB max)" placement="top">
                          @if (uploadingImageId === album.albumId) { <span class="spinner-border spinner-border-sm"></span> } @else { <i class="fa fa-upload"></i> }
                        </button>
                      </div>
                      |
                      <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(album)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          <br/>
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + albums.length }} of {{ totalResults }} entries
            </small>
            <ul class="pagination pagination-sm mb-0">
              <li class="page-item" [class.disabled]="pageNumber <= 1">
                <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
              </li>
              @for (page of getPageNumbers(); track $index) {
                @if (page === null) {
                  <li class="page-item disabled"><span class="page-link">...</span></li>
                } @else {
                  <li class="page-item" [class.active]="page === pageNumber">
                    <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                  </li>
                }
              }
              <li class="page-item" [class.disabled]="pageNumber >= totalPages">
                <button class="page-link" (click)="onClickPaginationNext()" [disabled]="pageNumber >= totalPages">&raquo;</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<input #imageInput type="file" accept="image/png" style="display:none" (change)="onImageSelected($event)">

<app-collection-album-add-modal #addModal [collectionId]="collectionId"></app-collection-album-add-modal>
<app-collection-album-edit-modal #editModal [collectionId]="collectionId"></app-collection-album-edit-modal>
